export const brandNames = {
  shoemall: 'SMSite',
  stoneberry: 'ZBSite',
  masseys: 'ZYSite',
  masonEasyPay: 'ZDSite',
  marylandSquare: 'MQSite',
};

export const cartLabelBrands = ['ZBSite', 'ZYSite', 'ZDSite'];
